(function () {
  "use strict";

  var MAX_BYTES = 10 * 1024 * 1024;
  var ALLOWED_TYPES = ["image/jpeg", "image/jpg", "image/png"];

  function init() {
    var roots = document.querySelectorAll("[data-ia-visualizer-root]:not([data-ia-visualizer-initialized])");
    roots.forEach(setupModal);
  }

  function setupModal(root) {
    root.setAttribute("data-ia-visualizer-initialized", "true");

    var closeEls = root.querySelectorAll("[data-ia-visualizer-close]");
    var fileInput = root.querySelector("[data-ia-visualizer-file-input]");
    var dropzone = root.querySelector("[data-ia-visualizer-dropzone]");
    var preview = root.querySelector("[data-ia-visualizer-preview]");
    var previewImg = root.querySelector("[data-ia-visualizer-preview-img]");
    var placeholder = root.querySelector("[data-ia-visualizer-placeholder]");
    var uploadError = root.querySelector("[data-ia-visualizer-upload-error]");
    var submitBtn = root.querySelector("[data-ia-visualizer-submit]");
    var retryBtns = root.querySelectorAll("[data-ia-visualizer-retry]");
    var resultImg = root.querySelector("[data-ia-visualizer-result-img]");
    var downloadLink = root.querySelector("[data-ia-visualizer-download]");
    var whatsappLink = root.querySelector("[data-ia-visualizer-whatsapp]");
    var whatsappFallback = root.querySelector("[data-ia-visualizer-whatsapp-fallback]");
    var errorMessageEl = root.querySelector("[data-ia-visualizer-error-message]");
    var addCartBtn = root.querySelector("[data-ia-visualizer-add-cart]");
    var cartErrorEl = root.querySelector("[data-ia-visualizer-cart-error]");
    var titleEl = root.querySelector("#ia-visualizer-title");

    var workerUrl = root.getAttribute("data-worker-url");
    var whatsappNumber = root.getAttribute("data-whatsapp-number");
    var productTitle, productImage, productUrl, variantId;

    var selectedFile = null;
    var lastFocusedEl = null;

    // Lê o produto atual do modal (pode ser trocado por um botão de card).
    function readProduct() {
      productTitle = root.getAttribute("data-product-title");
      productImage = root.getAttribute("data-product-image");
      productUrl = root.getAttribute("data-product-url");
      variantId = root.getAttribute("data-variant-id");
      var href = "https://wa.me/" + whatsappNumber + "?text=" + root.getAttribute("data-whatsapp-message");
      if (whatsappLink) whatsappLink.setAttribute("href", href);
      if (whatsappFallback) whatsappFallback.setAttribute("href", href);
    }

    // Botões de card trazem os dados do próprio produto.
    function applyTrigger(t) {
      var title = t && t.getAttribute("data-product-title");
      if (!title) return;
      var url = t.getAttribute("data-product-url") || "";
      root.setAttribute("data-product-title", title);
      root.setAttribute("data-product-image", t.getAttribute("data-product-image") || "");
      root.setAttribute("data-product-url", url);
      root.setAttribute("data-variant-id", t.getAttribute("data-variant-id") || "");
      root.setAttribute(
        "data-whatsapp-message",
        encodeURIComponent("Olá! Vi o produto " + title + " no site e quero saber mais: " + url)
      );
      if (titleEl) titleEl.textContent = 'Ver "' + title + '" na sua casa';
    }

    readProduct();

    // Delegação: funciona para o botão da página de produto e para os dos cards.
    document.addEventListener("click", function (e) {
      var t = e.target && e.target.closest ? e.target.closest("[data-ia-visualizer-open]") : null;
      if (!t) return;
      e.preventDefault();
      openModal(t);
    });

    closeEls.forEach(function (el) {
      el.addEventListener("click", closeModal);
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !root.hidden) closeModal();
    });

    dropzone.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        fileInput.click();
      }
    });

    dropzone.addEventListener("dragover", function (e) {
      e.preventDefault();
      dropzone.classList.add("is-dragover");
    });

    dropzone.addEventListener("dragleave", function () {
      dropzone.classList.remove("is-dragover");
    });

    dropzone.addEventListener("drop", function (e) {
      e.preventDefault();
      dropzone.classList.remove("is-dragover");
      if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]) {
        handleFile(e.dataTransfer.files[0]);
      }
    });

    fileInput.addEventListener("change", function () {
      if (fileInput.files && fileInput.files[0]) {
        handleFile(fileInput.files[0]);
      }
    });

    submitBtn.addEventListener("click", function () {
      if (selectedFile) submitPhoto();
    });

    retryBtns.forEach(function (btn) {
      btn.addEventListener("click", resetToUpload);
    });

    if (addCartBtn) {
      addCartBtn.addEventListener("click", addToCart);
    }

    function openModal(trigger) {
      lastFocusedEl = document.activeElement;
      applyTrigger(trigger);
      readProduct();
      root.hidden = false;
      document.body.style.overflow = "hidden";
      resetToUpload();
    }

    function closeModal() {
      root.hidden = true;
      document.body.style.overflow = "";
      if (lastFocusedEl && lastFocusedEl.focus) lastFocusedEl.focus();
    }

    function showStep(name) {
      root.querySelectorAll("[data-ia-step]").forEach(function (el) {
        el.hidden = el.getAttribute("data-ia-step") !== name;
      });
    }

    function resetToUpload() {
      selectedFile = null;
      fileInput.value = "";
      preview.hidden = true;
      placeholder.hidden = false;
      uploadError.hidden = true;
      submitBtn.disabled = true;
      if (addCartBtn) {
        addCartBtn.disabled = false;
        addCartBtn.textContent = "Adicionar ao carrinho";
      }
      if (cartErrorEl) cartErrorEl.hidden = true;
      showStep("upload");
    }

    function handleFile(file) {
      uploadError.hidden = true;

      if (ALLOWED_TYPES.indexOf(file.type) === -1) {
        showUploadError("Formato inválido. Envie uma foto em JPG ou PNG.");
        return;
      }

      if (file.size > MAX_BYTES) {
        showUploadError("A foto excede o limite de 10MB.");
        return;
      }

      selectedFile = file;
      submitBtn.disabled = false;

      var reader = new FileReader();
      reader.onload = function (e) {
        previewImg.src = e.target.result;
        preview.hidden = false;
        placeholder.hidden = true;
      };
      reader.readAsDataURL(file);
    }

    function showUploadError(message) {
      uploadError.textContent = message;
      uploadError.hidden = false;
      selectedFile = null;
      submitBtn.disabled = true;
    }

    function addToCart() {
      if (!variantId) {
        cartErrorEl.textContent = "Não foi possível identificar o produto. Atualize a página e tente novamente.";
        cartErrorEl.hidden = false;
        return;
      }

      cartErrorEl.hidden = true;
      addCartBtn.disabled = true;
      addCartBtn.textContent = "Adicionando...";

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) {
              throw new Error(data && data.description ? data.description : "Erro ao adicionar ao carrinho.");
            }
            return data;
          });
        })
        .then(function () {
          window.location.href = "/cart";
        })
        .catch(function (err) {
          cartErrorEl.textContent =
            (err && err.message) || "Não conseguimos adicionar ao carrinho agora. Tente novamente.";
          cartErrorEl.hidden = false;
          addCartBtn.disabled = false;
          addCartBtn.textContent = "Adicionar ao carrinho";
        });
    }

    function submitPhoto() {
      showStep("loading");

      var formData = new FormData();
      formData.append("photo", selectedFile);
      formData.append("productImageUrl", productImage);
      formData.append("productTitle", productTitle);

      fetch(workerUrl, {
        method: "POST",
        body: formData,
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) {
              throw new Error(data && data.error ? data.error : "Erro ao gerar visualização.");
            }
            return data;
          });
        })
        .then(function (data) {
          if (!data.image) throw new Error("Resposta inesperada do servidor.");
          resultImg.src = data.image;
          downloadLink.href = data.image;
          showStep("result");
        })
        .catch(function (err) {
          errorMessageEl.textContent =
            (err && err.message) ||
            "Não conseguimos gerar a visualização agora. Tente novamente ou fale com a gente no WhatsApp.";
          showStep("error");
        });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
